function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcc30b;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Artboard 1");

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  id: "_Path_",
  "data-name": "<Path>",
  className: "cls-1",
  y: -0.02,
  width: 1000,
  height: 1000.03
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  id: "_Path_2",
  "data-name": "<Path>",
  className: "cls-2",
  points: "102.57 111.45 154.92 111.45 109.7 285.42 143.32 285.42 187.63 115.02 187.63 83.79 102.57 83.79 102.57 111.45"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  id: "_Compound_Path_",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M500,484.49A146.58,146.58,0,1,0,646.52,631.06,146.56,146.56,0,0,0,500,484.49m-10.85,57.9c0-4.87,4.89-10.25,10.91-10.25s10.85,5.38,10.85,10.25v50.33c0,4.85-4.85,10.17-10.85,10.17s-10.91-5.32-10.91-10.17ZM500,706.16a76.24,76.24,0,0,1-22.65-149v28.39a49.89,49.89,0,1,0,45.18-.07V557.09A76.24,76.24,0,0,1,500,706.16"
}), React.createElement("path", {
  id: "_Path_3",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M331.73,629.78c0-6.65-5.89-12-11.26-12H256.28c-5.41,0-11.35,5.38-11.35,12s5.94,12.07,11.35,12.07h64.19c5.37,0,11.26-5.41,11.26-12.07"
}), React.createElement("path", {
  id: "_Path_4",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M755.07,629.78c0-6.65-5.89-12-11.26-12H679.63c-5.41,0-11.35,5.38-11.35,12s5.94,12.07,11.35,12.07h64.18c5.37,0,11.26-5.41,11.26-12.07"
}), React.createElement("path", {
  id: "_Path_5",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M500,461.53c6.63,0,12-5.89,12-11.26V386.08c0-5.41-5.39-11.35-12-11.35s-12.09,5.94-12.09,11.35v64.19c0,5.37,5.43,11.26,12.09,11.26"
}), React.createElement("path", {
  id: "_Path_6",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M500,884.86c6.63,0,12-5.89,12-11.26V809.42c0-5.4-5.39-11.35-12-11.35s-12.09,5.95-12.09,11.35V873.6c0,5.37,5.43,11.26,12.09,11.26"
}), React.createElement("path", {
  id: "_Path_7",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M354,546.19c3.31-5.77.88-13.36-3.8-16l-55.7-31.88c-4.7-2.69-12.52-1-15.83,4.8s-.83,13.43,3.86,16.12l55.71,31.88c4.66,2.67,12.46.9,15.76-4.89"
}), React.createElement("path", {
  id: "_Path_8",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M721.39,756.47c3.29-5.75.86-13.36-3.8-16l-55.7-31.88c-4.7-2.68-12.53-1-15.83,4.81s-.84,13.43,3.85,16.11l55.71,31.88c4.66,2.67,12.46.9,15.77-4.89"
}), React.createElement("path", {
  id: "_Path_9",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M583.61,483.77c5.76,3.29,13.35.86,16-3.8l31.87-55.71c2.7-4.7,1-12.53-4.79-15.83s-13.44-.84-16.12,3.86L578.72,468c-2.67,4.67-.9,12.47,4.89,15.78"
}), React.createElement("path", {
  id: "_Path_10",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M373.33,851.19c5.76,3.29,13.35.86,16-3.81l31.87-55.7c2.69-4.69,1-12.53-4.8-15.83S403,775,400.32,779.71l-31.88,55.7c-2.67,4.66-.9,12.47,4.89,15.78"
}), React.createElement("path", {
  id: "_Path_11",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M416.14,483.91c5.75-3.31,7.49-11.1,4.81-15.76l-32-55.64c-2.7-4.69-10.32-7.15-16.08-3.84s-7.51,11.17-4.8,15.86l32,55.63c2.69,4.66,10.3,7.07,16.09,3.75"
}), React.createElement("path", {
  id: "_Path_12",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M627.17,850.9c5.76-3.31,7.49-11.1,4.82-15.75l-32-55.64c-2.7-4.7-10.32-7.16-16.09-3.85s-7.51,11.17-4.79,15.87l32,55.63c2.68,4.66,10.3,7.06,16.08,3.74"
}), React.createElement("path", {
  id: "_Path_13",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M645.89,545.93c3.31,5.76,11.09,7.49,15.75,4.82l55.63-32c4.7-2.7,7.18-10.33,3.86-16.09s-11.16-7.5-15.86-4.8l-55.63,32c-4.67,2.68-7.07,10.31-3.75,16.08"
}), React.createElement("path", {
  id: "_Path_14",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M278.9,757c3.31,5.76,11.09,7.49,15.76,4.81l55.63-32c4.69-2.7,7.17-10.33,3.84-16.09s-11.16-7.5-15.85-4.81l-55.63,32c-4.67,2.67-7.07,10.31-3.75,16.08"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "_Group_",
  "data-name": "<Group>"
}, React.createElement("path", {
  id: "_Compound_Path_2",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M283.48,165.4l15.43-81.73h15.68l15.55,81.73H316l-2.53-14.94H298.91L296.5,165.4Zm17.24-25.92h11l-5.42-32.79h-.12Z"
}), React.createElement("path", {
  id: "_Compound_Path_3",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M335.2,83.67h32.19V94.88H348.94v23.39h13.75v11.09H348.94v36H335.2Z"
}), React.createElement("path", {
  id: "_Compound_Path_4",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M372.81,83.67H405V94.88H386.55v23.39H400.3v11.09H386.55v36H372.81Z"
}), React.createElement("path", {
  id: "_Compound_Path_5",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M409.22,144.31V104.76C409.22,92,415.49,82.7,430,82.7s20.86,9.28,20.86,22.06v39.55c0,12.66-6.27,22.06-20.86,22.06S409.22,157,409.22,144.31Zm27.85,2.17V102.59c0-4.94-2.17-8.44-7.12-8.44s-7,3.5-7,8.44v43.89c0,4.94,2.17,8.44,7,8.44S437.07,151.42,437.07,146.48Z"
}), React.createElement("path", {
  id: "_Compound_Path_6",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M471.78,127.91V165.4H458V83.67h20C491.92,83.67,497,90.54,497,102v10.49c0,8.8-3.13,14-11,15.79l13.14,37.13H484.68Zm0-33v25.43h4.58c4.71,0,6.76-2.41,6.76-6.75v-12c0-4.46-2.05-6.63-6.76-6.63Z"
}), React.createElement("path", {
  id: "_Compound_Path_7",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M545,105.61v37.85c0,12.54-5.18,21.94-19.89,21.94H503.85V83.67h21.22C539.78,83.67,545,93,545,105.61Zm-21.58,48.58c5.67,0,7.84-3.37,7.84-8.32v-42.8c0-4.82-2.17-8.19-7.84-8.19h-5.79v59.31Z"
}), React.createElement("path", {
  id: "_Compound_Path_8",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M548.21,165.4l15.43-81.73h15.68l15.55,81.73H580.76l-2.53-14.94H563.64l-2.41,14.94Zm17.24-25.92h11L571,106.69h-.12Z"
}), React.createElement("path", {
  id: "_Compound_Path_9",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M599.93,83.67h19.89c13.75,0,18.33,6.38,18.33,18V110c0,6.87-2.54,11.21-8.2,13,6.87,1.56,10.25,6.15,10.25,13.62v10.85c0,11.57-5.19,18-18.93,18H599.93Zm13.74,34.48h4.83c4.46,0,6.51-2.3,6.51-6.64v-10c0-4.46-2-6.63-6.63-6.63h-4.71Zm0,10.48v25.56h6c4.58,0,6.75-2.29,6.75-6.63v-12.3c0-4.34-2.05-6.63-6.87-6.63Z"
}), React.createElement("path", {
  id: "_Compound_Path_10",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M646.46,83.67h13.75v70.52H676.6V165.4H646.46Z"
}), React.createElement("path", {
  id: "_Compound_Path_11",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M682.26,83.67h32.8V94.88H696v23.39h13.62v11.09H696v24.83h19V165.4h-32.8Z"
}), React.createElement("path", {
  id: "_Compound_Path_12",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M731.69,165.4l15.43-81.73h15.67l15.56,81.73H764.24l-2.53-14.94H747.12l-2.41,14.94Zm17.24-25.92h11l-5.42-32.79h-.13Z"
}), React.createElement("path", {
  id: "_Compound_Path_13",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M795,114.05V165.4H783.41V83.67h13.5l14.83,46.89V83.67h11.45V165.4H811.14Z"
}), React.createElement("path", {
  id: "_Compound_Path_14",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M871.53,105.61v37.85c0,12.54-5.18,21.94-19.89,21.94H830.42V83.67h21.22C866.35,83.67,871.53,93,871.53,105.61ZM850,154.19c5.67,0,7.84-3.37,7.84-8.32v-42.8c0-4.82-2.17-8.19-7.84-8.19h-5.78v59.31Z"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "_Group_2",
  "data-name": "<Group>"
}, React.createElement("path", {
  id: "_Compound_Path_15",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M285.54,264.33V225c0-12.71,6-22,20.39-22,15.11,0,19.31,8.4,19.31,20.39V233H312.76V222.35c0-5-1.68-7.91-6.59-7.91s-7,3.47-7,8.39v43.66c0,4.92,2,8.39,7,8.39s6.59-3.12,6.59-7.91V252h12.48v14c0,11.63-4.8,20.27-19.31,20.27S285.54,276.92,285.54,264.33Z"
}), React.createElement("path", {
  id: "_Compound_Path_16",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M333.87,204h13.67v70.16h16.31v11.16h-30Z"
}), React.createElement("path", {
  id: "_Compound_Path_17",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M371.29,204h32.62v11.16H385v23.26h13.55v11H385v24.7h19v11.16H371.29Z"
}), React.createElement("path", {
  id: "_Compound_Path_18",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M410.27,285.32,425.62,204h15.59l15.47,81.32h-14l-2.52-14.87H425.62l-2.4,14.87Zm17.15-25.79h10.91l-5.4-32.62h-.12Z"
}), React.createElement("path", {
  id: "_Compound_Path_19",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M475,234.23v51.09H463.51V204H477l14.75,46.66V204h11.39v81.32h-12Z"
}), React.createElement("path", {
  id: "_Compound_Path_20",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M539.67,204h32.62v11.16H553.34v23.26h13.55v11H553.34v24.7h18.95v11.16H539.67Z"
}), React.createElement("path", {
  id: "_Compound_Path_21",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M592,234.23v51.09H580.45V204h13.43l14.75,46.66V204H620v81.32H608Z"
}), React.createElement("path", {
  id: "_Compound_Path_22",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M628.9,204h32.62v11.16H642.57v23.26h13.55v11H642.57v24.7h18.95v11.16H628.9Z"
}), React.createElement("path", {
  id: "_Compound_Path_23",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M683.47,248v37.3H669.79V204H689.7c13.8,0,18.83,6.84,18.83,18.23v10.44c0,8.75-3.12,13.91-10.91,15.71l13.07,36.94H696.3Zm0-32.86v25.3H688c4.68,0,6.72-2.4,6.72-6.71v-12c0-4.44-2-6.59-6.72-6.59Z"
}), React.createElement("path", {
  id: "_Compound_Path_24",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M737.79,241.9h19.43v43.42h-9.83v-8.88c-1.8,6.12-5.64,9.84-13.07,9.84-11.76,0-17.15-9.36-17.15-21.95V225c0-12.71,6.11-22,20.5-22,15.12,0,19.55,8.4,19.55,20.39v7.2H744.75v-8.28c0-5-1.92-7.91-6.83-7.91s-7.08,3.47-7.08,8.39v43.66c0,4.92,2,8.39,6.71,8.39,4.44,0,6.72-2.52,6.72-7.79V252.7h-6.48Z"
}), React.createElement("path", {
  id: "_Compound_Path_25",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M792.6,254.37v30.95H778.93V254.37L763.7,204H778l8.28,30.83h.12L794.64,204h13.07Z"
}));

var SvgColorGoal07 = function SvgColorGoal07(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgColorGoal07, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Color_Goal_07.3ef7b883.svg";
export { ForwardRef as ReactComponent };